export default __webpack_public_path__ + "static/background-0-85c09750d82300073baaf4f3a17bd768.png";